import {
  ServerType,
  TradeCommandType,
  BondBuyMode,
  Trade,
  BondConfigItem,
  Signals,
} from '@bdswiss/mt4-connector'
import { closedPositionsQuery, Currency, getAllowedLeveragesQuery } from '../graphql/schema'
import { I18nState } from 'react-redux-i18n'
import { AppConfig } from './AppConfig'
import { ModalState } from './dialog-types'
import { Bar } from '../lib/charting_library/types/datafeed-api'
import {TelegramSignalsState} from "../reducers/telegramSignals";

export declare type AppType = 'forex' | 'bond'

export interface RootState {
  allowedLeverages: getAllowedLeveragesQuery
  appConfig: AppConfig
  appState: AppState
  bondListState: BondListState
  bondsTradingPane: BondTradingPane
  candles: CandlesData
  favourites: string[]
  history: closedPositionsQuery
  i18n: I18nState
  modal: ModalState | null
  positionsInputs: PositionsInputs
  signals: Signals
  simpleSignals: SimpleSignal[]
  telegramSignals: TelegramSignalsState
  tradingAccounts: ViewerWrapper
  tradingPane: TradingPane
  userAccount: ViewerWrapper
}

export interface Trades {
  [key: number]: Trade
}

export declare type AppMode = 'trade' | 'positions' | 'orders' | 'history' | 'assetPosition'
export declare type ChartMode = 'open' | 'pending' | 'trade'
export declare type PositionsMode = 'open' | 'pending' | 'closed'
export declare type AppTheme = 'Light' | 'Dark'

export interface AppState {
  appType: AppType
  accountLoaded: boolean
  assetLoaded: boolean
  activeAccount: string
  positionsOpened: boolean
  positionsMode?: PositionsMode
  assetsOpened: boolean
  tradingPaneOpened: boolean
  editPaneOpened: boolean
  sidebarOpened: boolean
  symbol: string
  currency: string
  chartMode: ChartMode
  range?: { from: number; to: number; timeScale: number; interval: string }
  selectedPosition?: number
  positionExpanded?: boolean
  selectedOrder?: number
  orderExpanded?: boolean
  appMode: AppMode
  appTheme: AppTheme
  signal?: any
  dismissedRiscDisclaimer: boolean
  refreshChart?: boolean
}

export interface ViewerWrapper {
  viewer: {
    id: number
    email: string
    locale: string
    company: string
    isPhoneVerificationRequired: boolean
    accounts: AccountDetails[]
  }
}

export interface AccountDetails {
  id: number
  login: string
  mobile: boolean
  balance: number
  currency: Currency
  __typename: string
  serverType: ServerType
  coupons?: CouponInfo[]
  metaTraderApiUrl: string
  isArchived: boolean
  hidden: boolean
  accountSubtype: string
  swapFree: boolean
  isDemo: boolean
  symbolOverrides: {
    symbol: string
    marginDivider: number
  }[]
}

export interface TradingPaneValues {
  value: number
  valueAccount: number
  requiredMargin: number
  requiredMarginAccount: number
  takeProfitEnabled: boolean
  takeProfitInitial: number
  takeProfit: number
  profit: number
  profitPercent: number
  stopLossEnabled: boolean
  stopLossInitial: number
  stopLoss: number
  loss: number
  lossPercent: number
  pendingOrderEnabled: boolean
  priceInitial: number
  price: number
}

export interface TradingPane {
  tradeOperationEnabled: boolean
  lotsInitial: number
  lots: number
  lotsInput: number
  amountInitial: number
  amount: number
  amountInput: number
  tradeType: TradeCommandType
  buy: TradingPaneValues
  sell: TradingPaneValues
}

export interface BondTradingPane {
  tradeOperationEnabled: boolean
  amountInitial: number
  amount: number
  rate: number
  bondBuyMode: BondBuyMode
  showBondDetailDialog: boolean
}

// bonds section

export interface BondListState {
  selectedBond?: BondConfigItem
  viewBondDetails: boolean
}

export interface PositionInput {
  slInput?: number
  tpInput?: number
  priceInput?: number
}

export interface PositionsInputs {
  [order: number]: PositionInput
}

export interface CouponInfo {
  bond: string
  ticket: number
  date: Date
  amount: number
}

export interface BondTrade {
  trade: Trade
  bond: BondConfigItem
  coupons: CouponInfo[]
}

export interface BondClosedPosition {
  closedTrade: any
  bond: BondConfigItem
  coupons: CouponInfo[]
}

export interface CandlesData {
  symbol: string
  resolution: number
  bars: Map<number, Bar>
}

export enum TradeMode {
  disabled,
  onlyClose,
  enabled,
  onlyBuy,
  onlySell,
}

export interface ClientSignalStats {
  availableSignals: number,
  used_signals: number
}

export interface SimpleSignal {
  id: number
  clientId: number
  symbol: string
  direction: 'BUY' | 'SELL'
  message: string,
  timeFrameStart: string
  createdAt: string
}


export interface TelegramSignalReply {
  messageId: number
  pair: string
  reply: string
  replyMessageId: number
  timestamp: string
}
export interface TelegramSignal {
  buyZone: number[]
  exchanges: string
  leverage: string
  messageId: number
  pair: string,
  replies: TelegramSignalReply[]
  sell: number[],
  stopLoss: number
  timestamp: string
  type: "SHORT" | "LONG"
}
export interface TelegramSignalsResponse {
  clientStatistics: {
    availableSignals: number,
    usedSignals: number
  },
  signals: TelegramSignal[]
}

export interface ClientSignals {
  user_statistics: ClientSignalStats

  signals: SimpleSignal[]
}


export enum SignalType {

  None = 0,
  Autochartist,
  Simple,
  Telegram,
}
